import { useCallback, useEffect, useRef } from "react";
export const usePolling = () => {
    const intervalRef = useRef();
    const startPolling = useCallback((asyncCall, delay) => {
        intervalRef.current = setInterval(asyncCall, delay);
    }, []);
    const stopPolling = useCallback(() => {
        clearInterval(intervalRef.current);
    }, []);
    useEffect(() => {
        return () => stopPolling();
    }, []);
    return { startPolling, stopPolling };
};
//# sourceMappingURL=usePolling.js.map